import { createContext, useContext, useState, useEffect } from "react";
import { fetchSecure } from "./utils/utils";

const MyContext = createContext();

export const MyContextProvider = ({ children }) => {
  const [data, setData] = useState({
    adminToolChatBot: "",
    environmentName: "",
  });
  const [configData, setConfigData] = useState({});
  const [userData, setUserData] = useState(null); // Added userData state
  const [userId, setUserId] = useState(null); /* Vik (Jan 21, 2026) : Added userId state */
  const [authConfig, setAuthConfig] = useState({
    sessionId: sessionStorage.getItem("sessionId") || {},
  });
  //const [data, setData] = useState(null)
  const token =
    localStorage.getItem("access_token") || localStorage.getItem("token");
  useEffect(() => {
    //console.log("IN HERE MyContextProvider useEffect");
    async function loadAdminConfig() {
      try {
        console.log("BEFORE");
        const response = token
          ? await fetchSecure("/api/getAdminConfig")
          : await fetch("/api/getAdminConfig");

        if (!response.ok) {
          console.warn(
            `getAdminConfig returned ${response.status}, using defaults`,
          );
          setData({
            adminToolChatBot: "",
            environmentName: process.env.ENVIRONMENT_NAME || "Development",
          });
          return;
        }

        const data = await response.json();
        console.log("AFTER");
        setData(
          data || {
            adminToolChatBot: "",
            environmentName: process.env.ENVIRONMENT_NAME || "Development",
          },
        );

        if (token) {
          console.log("BEFORE");
          try {
            const response2 = await fetchSecure("/api/getObjects/config");
            if (response2.ok) {
              const data2 = await response2.json();
              if (Array.isArray(data2) && data2.length > 0) {
                setConfigData(data2[0]);
              }
            }
          } catch (e2) {
            console.warn("Failed to load config, continuing without it", e2);
          }
        }
      } catch (e) {
        console.log(`Failed to load adminConfig`);
        console.log(e);
        console.log(e.stack);
        // Set default data on error
        setData({
          adminToolChatBot: "",
          environmentName: process.env.ENVIRONMENT_NAME || "Development",
        });
      }
    }
    loadAdminConfig();
  }, []);

  return (
    <MyContext.Provider
      value={{
        data,
        setData,
        configData,
        setConfigData,
        userData, // Add userData to context value
        setUserData, // Add setter for userData
        userId, /* Vik (Jan 21, 2026) : Added userId to context to avoid prop drilling */
        setUserId, /* Vik (Jan 21, 2026) : Added setter for userId */
        authConfig, // KAD added Mar 21, 2025 because I was trying to set a const in GlobalContext and you can't
        setAuthConfig, // KAD added Mar 21, 2025
      }}
    >
      {children}
    </MyContext.Provider>
  );
};

export const useMyContext = () => {
  return useContext(MyContext);
};
